<table
	mat-table
	[dataSource]="otherCharges"
	class="other-charges-item"
	[class.mb-3]="!(showOtherChargeFields$ | async)"
>
	<ng-container matColumnDef="autoRenew">
		<th mat-header-cell *matHeaderCellDef>
			<mat-icon matTooltip="Auto Renew">autorenew</mat-icon>
		</th>
		<td mat-cell *matCellDef="let item" class="auto-renew">
			<mat-icon *ngIf="item.autoRenew" matTooltip="Will auto renew"
				>done</mat-icon
			>
		</td>
	</ng-container>
	<ng-container matColumnDef="description">
		<th mat-header-cell *matHeaderCellDef>
			Description
		</th>
		<td mat-cell *matCellDef="let item" class="description">
			{{ item.description }}
		</td>
	</ng-container>
	<ng-container matColumnDef="chargeDate">
		<th mat-header-cell *matHeaderCellDef>
			Charge Date
		</th>
		<td mat-cell *matCellDef="let item" class="charge-date">
			{{ item.chargeDate | date: 'shortDate':'utc' }}
		</td>
	</ng-container>
	<ng-container matColumnDef="units">
		<th mat-header-cell *matHeaderCellDef>
			Units
		</th>
		<td mat-cell *matCellDef="let item" class="units">
			{{ item.units }}
		</td>
	</ng-container>
	<ng-container matColumnDef="unitPrice">
		<th mat-header-cell *matHeaderCellDef>
			Unit Price
		</th>
		<td mat-cell *matCellDef="let item" class="unit-price">
			{{ item.unitPrice | currency }}
		</td>
	</ng-container>
	<ng-container matColumnDef="amount">
		<th mat-header-cell *matHeaderCellDef>
			Amount
		</th>
		<td mat-cell *matCellDef="let item" class="amount">
			{{ item.amount | currency }}
		</td>
	</ng-container>
	<ng-container matColumnDef="serviceType">
		<th mat-header-cell *matHeaderCellDef>
			Service Type
		</th>
		<td mat-cell *matCellDef="let item" class="serviceType">
			{{ item.serviceType?.description }}
		</td>
	</ng-container>
	<ng-container matColumnDef="action">
		<th mat-header-cell *matHeaderCellDef>
			Action
		</th>
		<td mat-cell *matCellDef="let item; let i = index" class="actions">
			<button
				mat-icon-button
				(click)="editOtherCharge(item, i)"
				class="edit"
			>
				<mat-icon>edit</mat-icon>
			</button>
			<button
				mat-icon-button
				rpsharedConfirm="Delete charge item?"
				(onConfirmed)="deleteOtherCharge(i)"
				class="deleteBtn"
			>
				<mat-icon>delete</mat-icon>
			</button>
		</td>
	</ng-container>
	<tr mat-header-row *matHeaderRowDef="displayedColumns" class="heading"></tr>
	<tr
		mat-row
		*matRowDef="let row; columns: displayedColumns"
		class="other-charge"
	></tr>
</table>

<div class="other-charge-form" *ngIf="showOtherChargeFields$ | async">
	<rpfsa-other-charge
		[formControl]="otherChargeItem"
		[serviceTypes]="serviceTypes"
		(cancel)="cancelOtherCharge()"
		(save)="saveOtherCharge()"
	>
	</rpfsa-other-charge>
</div>
<div fxLayout fxLayoutAlign="end center">
	<button
		class="mr-4 add-charge"
		mat-mini-fab
		color="primary"
		(click)="addOtherCharge()"
		matTooltip="Add Charge"
	>
		<mat-icon>add</mat-icon>
	</button>
</div>
